import React from 'react'

export default function ShowFeatures({items}) {
  return (
    <div>
        <p style={{fontSize:'20px'}}>Features</p>
        { items.map( (item,index) =>{
            return <p key={index}> {item.feature} </p> ;
        }

        ) }


    </div>
  )
}
